import { useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import React from 'react'
import { HighlightCard } from 'ui/cards'
import { observer } from 'mobx-react'

function ScheduleWageRatioHighlightCard ({ week }) {
  const wageRatio = useValue('wage_ratio')
  const targetWageRatio = useValue('target_wage_ratio')

  const isBad = wageRatio > targetWageRatio

  const displayWageRatio = (targetWageRatio * 100).toFixed(0)

  return (
    <HighlightCard
      color={isBad ? 'red' : 'primary'}
      box={<Displays.Percentage name='wage_ratio' decimals={0} />}
      title={<Translation name='shifts.planner.week_x_wage_ratio' data={{ week: week }} />}
      content={<Translation name='shifts.planner.approved_wage_ratio' data={{ wage_ratio: displayWageRatio }} />}
    />
  )
}

export default observer(ScheduleWageRatioHighlightCard)
